import React from "react";
import '../css/client.css';

// Import client logos
import client1 from "../assets/c1.jpg";
import client2 from "../assets/c2.png";
import client3 from "../assets/c3.jpg";
import client4 from "../assets/c4.jpg";

export default function Client() {

    const clients = [
        { logo: client1, name: "Government Department" },
        { logo: client2, name: "NABARD" },
        { logo: client3, name: "Social Welfare Dept." },
        { logo: client4, name: "Private Organization" }
    ];

    return (
        <div className="client-section py-5">
            <div className="container">

                <div className="text-center mb-5">
                    <h2 className="client-heading">Our Clients & Partners</h2>
                    <p>Organizations and Government bodies we have worked with</p>
                </div>

                <div className="row align-items-center justify-content-center">
                    {clients.map((client, index) => (
                        <div className="col-6 col-md-4 col-lg-3 mb-4 text-center" key={index}>
                            <div className="client-card">
                                <img 
                                    src={client.logo} 
                                    alt={client.name} 
                                    className="img-fluid client-logo"
                                />
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </div>
    );
}